"use client";
import { jsxs as h, jsx as l } from "react/jsx-runtime";
const n = ({
  title: i,
  titleId: a,
  desc: d,
  descId: e,
  ...r
}) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-la",
    viewBox: "0 0 640 480",
    "aria-labelledby": a,
    "aria-describedby": e,
    ...r,
    children: [
      d ? /* @__PURE__ */ l("desc", { id: e, children: d }) : null,
      i ? /* @__PURE__ */ l("title", { id: a, children: i }) : null,
      /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "la-a", children: /* @__PURE__ */ l("path", { fillOpacity: 0.7, d: "M0 0h640v480H0z" }) }) }),
      /* @__PURE__ */ h("g", { fillRule: "evenodd", clipPath: "url(#la-a)", children: [
        /* @__PURE__ */ l("path", { fill: "#ce1126", d: "M-40 0h720v480H-40z" }),
        /* @__PURE__ */ l("path", { fill: "#002868", d: "M-40 119.3h720v241.4H-40z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#fff",
            d: "M423.4 240a103.4 103.4 0 1 1-206.8 0 103.4 103.4 0 1 1 206.8 0"
          }
        )
      ] })
    ]
  }
);
export {
  n as default
};
